<div class="ddp-input-number">
  <input type="number" [value]="value" />
  <div class="ddp-input-number-nav">
    <button (click)="onClickDown()" type="button" class="ddp-input-number-button ddp-input-number-down"></button>
    <button (click)="onClickUp()" type="button" class="ddp-input-number-button ddp-input-number-up"></button>
  </div>
</div>
